import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://0db50dfc285343a19583d07eec296388@o36100.ingest.sentry.io/4504571597160448',
    integrations: [new Integrations.BrowserTracing()],
    environment: import.meta.env.VITE_APP_ENV || 'development',
    release: 'relcore-central@' + import.meta.env.VITE_APP_VERSION,
    normalizeDepth: 5,
    beforeSend(event) {
      event.breadcrumbs = (event.breadcrumbs || []).filter(
        (b) =>
          b.data == null ||
          typeof b.data.arguments != 'object' ||
          b.data.arguments.length < 3 ||
          b.data.arguments[1].indexOf('color: #') !== 0
      );
      return event;
    }
  });
}

export default Sentry;
